import { render } from "./Home.vue?vue&type=template&id=45d79d12&bindings={\"data\":\"setup\"}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "../assets/bootstrap.css?vue&type=style&index=0&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script